import { render, staticRenderFns } from "./_VersionOutdated.vue?vue&type=template&id=25e3aba3"
import script from "./_VersionOutdated.vue?vue&type=script&lang=ts"
export * from "./_VersionOutdated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports